module.exports = __webpack_public_path__ + "static/media/notepad.9a2c282b.svg";